import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { errorToast, successToast } from '../../services/toast';
import useFormatPhotoTimestamp from '../../hooks/useFormatPhotoTimestamp';

const PickupPhotoTimestamps = ({ photo, serverTimezone }) => {
  const formattedTime = useFormatPhotoTimestamp(photo, serverTimezone);

  const onPhotoTimestampClick = useCallback(async (event) => {
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(formattedTime);
      successToast('Copied!', 750);
    } catch {
      errorToast('A copy error occurred!', 1000);
    }
  }, [formattedTime]);


  return <button className="btn-text" onClick={onPhotoTimestampClick}>{formattedTime}</button>;
};

PickupPhotoTimestamps.propTypes = {
  photo: PropTypes.instanceOf(Object).isRequired,
  serverTimezone: PropTypes.string.isRequired,
};

PickupPhotoTimestamps.defaultProps = {};

export default PickupPhotoTimestamps;
